<div class="screen-fit" [formGroup]="inscripcionForm">

    <!-- HEADER SUPERIOR -->
    <div class="row inscripcion-top-header w-100 mx-auto">

        <!-- Espacio izquierdo -->
        <div class="col-2 header-side-space"></div>

        <!-- Logos centrados -->
        <div class="col-8 sponsor-logos-header">

            <div class="sponsor-logo-item" *ngIf="getLogoDefault()">
                <img [src]="getLogoDefault()" [alt]="getNombreDefault()" class="sponsor-logo-img">
            </div>

            <div class="sponsor-separator" *ngIf="showLogoCustomer()"></div>

            <div class="sponsor-logo-item" *ngIf="showLogoCustomer()">
                <img [src]="getLogoCustomer()" [alt]="getNombreCustomer()"
                    class="sponsor-logo-img sponsor-logo-customer">
            </div>

        </div>

        <!-- Mesa de ayuda derecha -->
        <div class="col-2 header-help-column">
            <a class="header-help-box" *ngIf="getTelefonoCustomer()" [href]="getTelefonoCustomerHref()"
                aria-label="Mesa de ayuda">

                <span class="header-help-icon">
                    <i class="fi fi-rr-headset"></i>
                </span>

                <span class="header-help-content">
                    <span class="header-help-label">Mesa de ayuda</span>
                    <strong class="header-help-number">{{ getTelefonoCustomer() }}</strong>
                </span>

            </a>
        </div>

    </div>

    <!-- STEPPER SUPERIOR -->
    <div class="inscripcion-stepper" *ngIf="!showSuccessPaymentScreen && !showFailedPaymentScreen && !loadingPaymentReturn">

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 1, 'completed': currentStep > 1 }"
            (click)="goToStep(1)">
            <div class="stepper-circle">1</div>
            <div class="stepper-label">Selección de plan</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 2, 'completed': currentStep > 2 }"
            (click)="goToStep(2)">
            <div class="stepper-circle">2</div>
            <div class="stepper-label">Datos del titular</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 3, 'completed': currentStep > 3 }"
            (click)="goToStep(3)">
            <div class="stepper-circle">3</div>
            <div class="stepper-label">Beneficiarios</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 4, 'completed': currentStep > 4 }"
            (click)="goToStep(4)">
            <div class="stepper-circle">4</div>
            <div class="stepper-label">Detalle y términos</div>
        </div>

        <div class="stepper-line"></div>

        <ng-container *ngIf="canValidateAutentika">
            <div class="stepper-item" [ngClass]="{ 'active': currentStep === 5, 'completed': currentStep > 5 }"
                (click)="goToStep(5)">
                <div class="stepper-circle">5</div>
                <div class="stepper-label">Identidad y firma</div>
            </div>

            <div class="stepper-line"></div>
        </ng-container>

        <div class="stepper-item"
            [ngClass]="{ 'active': currentStep === getPagoStep(), 'completed': currentStep > getPagoStep() }"
            (click)="goToStep(getPagoStep())">
            <div class="stepper-circle">{{ getPagoStep() }}</div>
            <div class="stepper-label">Inscripción de pago</div>
        </div>

    </div>

    <!-- LOADING -->
    <div class="row mt-xl-3 mx-0" *ngIf="loading">
        <div class="col-12 p-0">
            <div class="card p-4 text-center">
                <span class="title-step">Cargando información del convenio...</span>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!loading">

        <!-- LOADING RESTAURANDO CARRO -->
        <div class="row mt-xl-3 mx-0" *ngIf="loadingCartFromUrl">
            <div class="col-12 p-0">
                <div class="card p-4 text-center">
                    <span class="title-step">Recuperando inscripción pendiente...</span>
                </div>
            </div>
        </div>

        <!-- LOADING RETORNO MERCADO PAGO -->
        <div class="row mt-xl-3 mx-0" *ngIf="loadingPaymentReturn">
            <div class="col-12 p-0">
                <div class="card p-4 text-center">
                    <span class="title-step">Consultando estado de suscripción en {{ paymentReturnProviderName || 'el medio de pago' }}...</span>
                </div>
            </div>
        </div>

        <!-- CONVENIO NO DISPONIBLE -->
        <div class="row mt-xl-3 mx-0 justify-content-center" *ngIf="!convenioDisponible && !loadingCartFromUrl && !loadingPaymentReturn && !showSuccessPaymentScreen && !showFailedPaymentScreen">
            <div class="col-12 p-0" style="display: flex; justify-content: center;">
                <div class="card unavailable-card-template">

                    <div class="unavailable-icon-wrapper">
                        <div class="unavailable-icon-circle">
                            <i class="fi fi-rr-link-slash unavailable-main-icon"></i>
                        </div>
                    </div>

                    <p class="unavailable-convenio-name">
                        {{ getNombreConvenio() }}
                    </p>

                    <h1 class="unavailable-title">
                        El enlace de inscripción<br>
                        no se encuentra disponible
                    </h1>

                    <p class="unavailable-description">
                        Este enlace puede estar inactivo o el convenio<br class="d-none d-md-block">
                        ya no se encuentra vigente.
                    </p>

                    <div class="unavailable-info-line">
                        <i class="fi fi-rr-info"></i>
                        <span>
                            Por favor, contacta a AlmaMedis o al responsable de tu convenio.
                        </span>
                    </div>

                    <div class="unavailable-contact-box">
                        <div class="unavailable-contact-title">
                            <i class="fi fi-rr-info"></i>
                            <span>
                                Puedes llamarnos o escribirnos, estamos para ayudarte.
                            </span>
                        </div>

                        <div class="unavailable-contact-actions">
                            <a href="mailto:soporte@almamedis.cl" class="unavailable-contact-action">
                                <i class="fi fi-rr-envelope"></i>
                                <span>soporte@almamedis.cl</span>
                            </a>

                            <a href="tel:+56200000000" class="unavailable-contact-action">
                                <i class="fi fi-rr-phone-call"></i>
                                <span>+56 2 0000 0000</span>
                            </a>
                        </div>
                    </div>

                    <button type="button" class="unavailable-primary-btn" (click)="contactarAlmamedis()">
                        Contactar a AlmaMedis
                        <i class="fi fi-rr-arrow-right ml-2"></i>
                    </button>

                </div>
            </div>
        </div>

        <!-- FORMULARIO PRINCIPAL -->
        <div class="row mt-xl-3 mx-0 justify-content-center"
            *ngIf="convenioDisponible && !showSuccessPaymentScreen && !showFailedPaymentScreen && !loadingCartFromUrl && !loadingPaymentReturn">

            <div class="col-12 p-0 left-col-fill">

                <div class="card h-100 p-0 card-left form-card">

                    <!-- STEP 1 -->
                    <div *ngIf="steps.seleccionPlan">

                        <div class="form-content p-3 step1-content" [formGroup]="titularForm">

                            <h3 class="m-0 title-step">Elige tu plan</h3>
                            <h5 class="m-0 sub-title-step">Selecciona el plan que deseas contratar</h5>
                            <br>

                            <div class="step1-plans-scroll">
                                <div class="plans-grid" *ngIf="planesDisponibles.length > 0">
                                    <div class="plan-select-card" *ngFor="let plan of planesDisponibles"
                                        [ngClass]="{ 'selected': esPlanSeleccionado(plan) }"
                                        (click)="seleccionarPlan(plan)">

                                        <div class="plan-select-badge">
                                            {{ plan.cus_ben_name || plan.nombre }}
                                        </div>

                                        <!-- <div class="plan-select-subtitle">
                                            {{ getPlanSubtitulo(plan) }}
                                        </div> -->

                                        <!-- <div class="plan-select-separator"></div> -->

                                        <div class="plan-select-price">
                                            {{ formatPrecioPlan(plan.cus_ben_price_titular) }}
                                        </div>

                                        <div class="plan-select-price-caption">
                                            Mensual IVA incluido
                                        </div>

                                        <div class="plan-select-features">

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-user"></i>
                                                    </div>
                                                    <span>Titular</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_titular) }}</strong>
                                            </div>

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-users"></i>
                                                    </div>
                                                    <span>Beneficiario 1</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_carga1) }}</strong>
                                            </div>

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-users-alt"></i>
                                                    </div>
                                                    <span>Beneficiarios adicionales</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_carga2) }} c/u</strong>
                                            </div>

                                            <div class="plan-select-feature"
                                                *ngIf="getEspecialidadesPlan(plan).length > 0">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-stethoscope"></i>
                                                    </div>
                                                    <span>{{ getEspecialidadesPlan(plan).length }}
                                                        especialidad(es)</span>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="plan-specialties-preview"
                                            *ngIf="getEspecialidadesPlan(plan).length > 0">

                                            <div class="plan-specialty-chip"
                                                *ngFor="let especialidad of getEspecialidadesVisiblesPlan(plan)">
                                                {{ especialidad.spe_name }}
                                            </div>

                                            <button type="button" class="plan-specialty-chip plan-specialty-chip-more"
                                                *ngIf="getEspecialidadesOcultasCount(plan) > 0"
                                                (click)="toggleEspecialidadesPlan(plan, $event)">
                                                {{
                                                isEspecialidadesPlanExpanded(plan)
                                                ? 'Ver menos'
                                                : '+' + getEspecialidadesOcultasCount(plan)
                                                }}
                                            </button>

                                        </div>

                                        <div class="plan-select-feature plan-phone-feature">
                                            <div class="plan-select-feature-main">
                                                <div class="plan-select-feature-icon">
                                                    <i class="fi fi-rr-phone-call"></i>
                                                </div>
                                                <span>Orientación de salud telefónica 24/7</span>
                                            </div>
                                        </div>

                                        <button type="button" class="plan-select-card-button"
                                            [ngClass]="{ 'selected': esPlanSeleccionado(plan) }"
                                            (click)="seleccionarPlan(plan); $event.stopPropagation();">
                                            {{ esPlanSeleccionado(plan) ? 'Plan seleccionado' : 'Seleccionar plan' }}
                                        </button>

                                    </div>
                                </div>

                                <div class="not-hours" *ngIf="planesDisponibles.length === 0">
                                    <div class="d-flex">
                                        <i class="fi fi-rr-info d-flex align-items-center"></i>
                                        <span>No hay planes disponibles para este convenio.</span>
                                    </div>
                                </div>
                            </div>

                            <small class="text-danger d-block mt-2"
                                *ngIf="titularForm.get('plan')?.touched && titularForm.get('plan')?.invalid">
                                Debes seleccionar un plan para continuar.
                            </small>

                            <div class="form-footer col-12 mt-4 px-0 step1-footer-fixed">
                                <div class="d-flex justify-content-end align-items-center footer-actions">
                                    <button type="button" class="btn btn-secondary btn-pill"
                                        [disabled]="!isStep1Valid()" (click)="nextFromStep1()">
                                        Continuar
                                        <i class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- STEP 2 -->
                    <div *ngIf="steps.titular">

                        <div class="form-content px-4 py-3 step2-content" formGroupName="titular">

                            <h3 class="m-0 title-step">Datos del titular</h3>
                            <h5 class="m-0 sub-title-step">Completa los datos de inscripción del titular</h5>
                            <!-- <br> -->

                            <div class="step2-plan-summary-card" *ngIf="getPlanSeleccionado()">
                                <div class="step2-plan-top">
                                    <div>
                                        <span>Plan seleccionado</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_name }}</strong>
                                    </div>
                                    <button type="button" class="step2-change-plan-btn" (click)="goToStep1()">
                                        <i class="fi fi-rr-edit"></i>
                                        Cambiar plan
                                    </button>
                                </div>
                                <div class="step2-price-main">
                                    <span>Valor mensual del plan</span>
                                    <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                </div>
                                <button type="button" class="step2-detail-toggle"
                                    (click)="toggleDetallePrecioTitular()">
                                    {{ mostrarDetallePrecioTitular ? 'Ocultar detalle del precio' : 'Ver detalle del
                                    precio' }}
                                    <i class="fi"
                                        [ngClass]="mostrarDetallePrecioTitular ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'">
                                    </i>
                                </button>

                                <div class="step2-price-detail" *ngIf="mostrarDetallePrecioTitular">

                                    <div class="step2-price-detail-row" *ngFor="let item of getDetallePrecioTitular()">
                                        <span>{{ item.label }}</span>
                                        <strong>{{ formatPrecioPlan(item.amount) }}</strong>
                                    </div>
                                    <div class="step2-price-detail-row step2-price-detail-total">
                                        <span>Total</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="form-row">

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">RUT del titular*</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Ej: 12.345.678-9" formControlName="rut"
                                        (input)="onTitularRutInput()"
                                        (blur)="onRutBlur()"
                                        (keypress)="allowOnlyRutChars($event)">

                                    <small class="text-info d-block mt-1" *ngIf="checkingTitularPlanExist">
                                        Validando RUT y plan seleccionado...
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('rut')?.touched && titularForm.get('rut')?.hasError('required')">
                                        El RUT del titular es obligatorio.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('rut')?.touched && titularForm.get('rut')?.hasError('rutInvalido')">
                                        El RUT ingresado no es válido.
                                    </small>

                                    <small class="text-danger d-block"
                                        *ngIf="shouldShowTitularPlanValidationMessage()">
                                        {{ titularRutPlanValidationMessage }}
                                    </small>
                                </div>



                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Nombre*</label>

                                    <input type="text" class="form-control form-control-rounded" placeholder="Nombre"
                                        formControlName="nombre" (keypress)="allowOnlyLetters($event)">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('nombre')?.touched && titularForm.get('nombre')?.hasError('required')">
                                        El nombre es obligatorio.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Primer apellido*</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Primer apellido" formControlName="primerApellido"
                                        (keypress)="allowOnlyLetters($event)">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('primerApellido')?.touched && titularForm.get('primerApellido')?.hasError('required')">
                                        El primer apellido es obligatorio.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Segundo apellido</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Segundo apellido" formControlName="segundoApellido"
                                        (keypress)="allowOnlyLetters($event)">
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Fecha de nacimiento*</label>

                                    <input type="date" class="form-control form-control-rounded"
                                        formControlName="fechaNacimiento" [attr.max]="todayDate">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('fechaNacimiento')?.touched && titularForm.get('fechaNacimiento')?.hasError('required')">
                                        La fecha de nacimiento es obligatoria.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('fechaNacimiento')?.touched && titularForm.get('fechaNacimiento')?.hasError('fechaMayorActual')">
                                        La fecha de nacimiento no puede ser mayor a la fecha actual.
                                    </small>
                                </div>

                            </div>
                            <div class="form-row">

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Email*</label>

                                    <input type="email" class="form-control form-control-rounded"
                                        placeholder="ejemplo@correo.cl" formControlName="email">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('email')?.touched && titularForm.get('email')?.hasError('required')">
                                        El email es obligatorio.
                                    </small>

                                    <small class="text-danger"
                                        *ngIf="titularForm.get('email')?.touched && titularForm.get('email')?.hasError('emailFormatoInvalido')">
                                        El correo ingresado no tiene un formato válido.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">

                                    <div class="form-row no-gutters">

                                        <div class="col-4 col-md-4 pr-2">
                                            <label class="label-sm">Código de Área</label>

                                            <div class="custom-select-flag" (click)="toggleFlagDropdown()"
                                                [class.open]="flagDropdownOpen">

                                                <div class="selected d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <span class="fi mr-2" [ngClass]="selectedAreaCode?.cou_flag"
                                                            style="font-size: 10px;">
                                                        </span>

                                                        (+{{ selectedAreaCode?.cou_phone_code }})
                                                    </div>

                                                    <i class="fi fi-rr-angle-small-down"></i>
                                                </div>

                                                <div class="options" *ngIf="flagDropdownOpen">
                                                    <div class="option" *ngFor="let areaCode of areaCodes"
                                                        (click)="selectAreaCode(areaCode); $event.stopPropagation();">

                                                        <span class="fi mr-2" [ngClass]="areaCode.cou_flag"></span>
                                                        (+{{ areaCode.cou_phone_code }})
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="col col-md-8">
                                            <label class="label-sm">Teléfono*</label>

                                            <input type="tel" class="form-control form-control-rounded"
                                                placeholder="Teléfono" formControlName="telefono"
                                                (input)="onTelefonoInput($event)" (keypress)="allowOnlyNumbers($event)"
                                                [attr.minlength]="selectedAreaCode?.cou_min_phone"
                                                [attr.maxlength]="selectedAreaCode?.cou_max_phone || 15">

                                            <small class="text-danger d-block mt-1"
                                                *ngIf="titularForm.get('telefono')?.touched && titularForm.get('telefono')?.hasError('required')">
                                                El teléfono es obligatorio.
                                            </small>

                                            <small class="text-muted d-block m-0" *ngIf="selectedAreaCode">
                                                Ingrese número entre {{ selectedAreaCode?.cou_min_phone }} y
                                                {{ selectedAreaCode?.cou_max_phone }} dígitos.
                                            </small>

                                            <small class="text-info d-block mt-1" *ngIf="shouldShowTelefonoMissingMessage()">
                                                {{ getTelefonoRemainingMessage() }}
                                            </small>
                                        </div>

                                    </div>
                                </div>

                                <div class="form-footer col-12">
                                    <div
                                        class="d-flex justify-content-between align-items-center footer-actions step2-form-actions">

                                        <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                            <i class="fi fi-rr-arrow-left mr-2"></i>

                                            Volver
                                        </button>

                                        <button type="button" class="btn btn-secondary btn-pill"
                                            [disabled]="!isStep2Valid() || checkingTitularPlanExist" (click)="nextFromStep2()">
                                            Continuar
                                            <i class="fi fi-rr-arrow-right ml-2"></i>
                                        </button>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- STEP 3 -->
                    <div *ngIf="steps.beneficiarios">

                        <div class="form-content px-4 py-3" [formGroup]="beneficiariosDecisionForm">

                            <h3 class="m-0 title-step">Beneficiarios</h3>
                            <h5 class="m-0 sub-title-step">
                                Indica si deseas agregar cargas o beneficiarios ahora, o si prefieres hacerlo después.
                            </h5>
                            <!-- <br> -->

                            <div class="step2-plan-summary-card" *ngIf="getPlanSeleccionado()">
                                <div class="step2-plan-top">
                                    <div>
                                        <span>Plan seleccionado</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_name }}</strong>
                                    </div>
                                    <button type="button" class="step2-change-plan-btn" (click)="goToStep1()">
                                        <i class="fi fi-rr-edit"></i>
                                        Cambiar plan
                                    </button>
                                </div>
                                <div class="step2-price-main">
                                    <span>Valor mensual del plan</span>
                                    <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                </div>
                                <button type="button" class="step2-detail-toggle"
                                    (click)="toggleDetallePrecioTitular()">
                                    {{ mostrarDetallePrecioTitular ? 'Ocultar detalle del precio' : 'Ver detalle del
                                    precio' }}
                                    <i class="fi"
                                        [ngClass]="mostrarDetallePrecioTitular ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'">
                                    </i>
                                </button>
                                <div class="step2-price-detail" *ngIf="mostrarDetallePrecioTitular">
                                    <div class="step2-price-detail-row" *ngFor="let item of getDetallePrecioTitular()">
                                        <span>{{ item.label }}</span>
                                        <strong>{{ formatPrecioPlan(item.amount) }}</strong>
                                    </div>
                                    <div class="step2-price-detail-row step2-price-detail-total">
                                        <span>Total</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>
                                </div>
                            </div>

                            <div class="beneficiarios-step-card">

                                <div class="beneficiarios-question-title">
                                    ¿Quieres agregar beneficiarios?
                                </div>

                                <div class="beneficiarios-choice-group">
                                    <button type="button" class="beneficiarios-choice-btn"
                                        [ngClass]="{ 'active': getDeseaAgregarBeneficiarios() === 'SI' }"
                                        (click)="seleccionarDeseaAgregarBeneficiarios('SI')">
                                        Sí
                                    </button>

                                    <button type="button" class="beneficiarios-choice-btn"
                                        [ngClass]="{ 'active': getDeseaAgregarBeneficiarios() === 'NO' }"
                                        (click)="seleccionarDeseaAgregarBeneficiarios('NO')">
                                        No
                                    </button>
                                </div>

                            </div>

                            <div class="beneficiarios-info-banner mt-3" *ngIf="getDeseaAgregarBeneficiarios() === 'NO'">
                                <div class="beneficiarios-info-banner-top">
                                    <i class="fi fi-rr-info"></i>
                                    <span>
                                        Para agregar beneficiarios posteriormente, debes ingresar a tu perfil en la
                                        plataforma de telemedicina a la sección:
                                    </span>
                                </div>
                                <div class="beneficiarios-info-route">
                                    <span>Mi perfil</span>
                                    <span class="route-separator">›</span>
                                    <span>Mis planes y convenios</span>
                                    <span class="route-separator">›</span>
                                    <span>Detalle del plan</span>
                                    <span class="route-separator">›</span>
                                    <strong>Modificar beneficiarios</strong>
                                </div>
                            </div>

                            <ng-container *ngIf="getDeseaAgregarBeneficiarios() === 'SI'">

                                <div class="beneficiarios-step-card mt-3">
                                    <div class="beneficiarios-question-title">
                                        ¿Cuántos beneficiarios quieres agregar?
                                    </div>

                                    <div class="beneficiarios-count-grid">
                                        <button type="button" class="beneficiarios-count-btn"
                                            *ngFor="let cantidad of cantidadBeneficiariosOpciones"
                                            [ngClass]="{ 'active': getCantidadBeneficiariosDespuesSeleccionada() === cantidad }"
                                            (click)="seleccionarCantidadBeneficiariosDespues(cantidad)">
                                            {{ cantidad }}
                                        </button>
                                    </div>

                                    <small class="text-danger d-block mt-2"
                                        *ngIf="beneficiariosDecisionForm.touched && !getCantidadBeneficiariosDespuesSeleccionada()">
                                        Debes indicar cuántos beneficiarios deseas agregar.
                                    </small>
                                </div>

                                <div class="beneficiarios-info-banner mt-3"
                                    *ngIf="getCantidadBeneficiariosDespuesSeleccionada()">

                                    <div class="beneficiarios-info-banner-top">
                                        <i class="fi fi-rr-info"></i>
                                        <span>
                                            Este plan contará con
                                            {{ getCantidadBeneficiariosDespuesSeleccionada() }}
                                            {{ getCantidadBeneficiariosDespuesSeleccionada() === 1 ? 'cupo' : 'cupos' }}
                                            para beneficiarios. Puedes completar la información de ellos ahora o de
                                            forma posterior
                                            en la plataforma de telemedicina en la sección:
                                        </span>
                                    </div>
                                    
                                    <div class="beneficiarios-info-route">
<i class="fi fi-ts-track"></i>                                        <span>Mi perfil</span>
                                        <span class="route-separator">›</span>
                                        <span>Mis planes y convenios</span>
                                        <span class="route-separator">›</span>
                                        <span>Detalle del plan</span>
                                        <span class="route-separator">›</span>
                                        <strong>Modificar beneficiarios</strong>
                                    </div>
                                </div>

                            </ng-container>

                            <div class="beneficiarios-form-wrapper mt-3" *ngIf="isBeneficiariosAhoraFlow()">

                                <div class="beneficiarios-section-header">
                                    <div>
                                        <h5 class="title-step mb-1">Cargas / Beneficiarios</h5>
                                        <p class="beneficiarios-section-help mb-0">
                                            Completa los datos de los beneficiarios que tengas disponibles. La
                                            información de los beneficiarios pendientes la podrás completar
                                            posteriormente en tu perfil de la plataforma.
                                        </p>
                                    </div>

                                    <div class="beneficiarios-slots-counter">
                                        {{ getBeneficiariosCompletadosCount() }} / {{ getCantidadBeneficiariosActual()
                                        }}
                                        completado(s)
                                    </div>
                                </div>

                                <div class="beneficiarios-slots-list mt-3">

                                    <div class="beneficiario-slot-item"
                                        *ngFor="let beneficiario of beneficiarios.controls; let i = index"
                                        [ngClass]="{ 'completed': isBeneficiarioSlotCompleto(i), 'pending': !isBeneficiarioSlotCompleto(i) }">

                                        <div class="beneficiario-info">

                                            <div class="avatar-icon"
                                                [ngClass]="{ 'pending': !isBeneficiarioSlotCompleto(i) }">
                                                <i class="fi"
                                                    [ngClass]="isBeneficiarioSlotCompleto(i) ? 'fi-rr-user' : 'fi-rr-user-add'">
                                                </i>
                                            </div>

                                            <div>
                                                <div class="beneficiario-slot-title">
                                                    {{ getBeneficiarioSlotTitulo(i) }}
                                                </div>

                                                <ng-container
                                                    *ngIf="isBeneficiarioSlotCompleto(i); else beneficiarioPendiente">
                                                    <div class="beneficiario-name">
                                                        {{ beneficiario.value.nombre }}
                                                        {{ beneficiario.value.primerApellido }}
                                                        {{ beneficiario.value.segundoApellido }}
                                                    </div>

                                                    <div class="beneficiario-rut">
                                                        RUT: {{ beneficiario.value.rut }}
                                                    </div>

                                                    <div class="beneficiario-rut" *ngIf="beneficiario.value.email">
                                                        Email: {{ beneficiario.value.email }}
                                                    </div>
                                                </ng-container>

                                                <ng-template #beneficiarioPendiente>
                                                    <div class="beneficiario-slot-pending-text">
                                                        Espacio pendiente de completar
                                                    </div>
                                                </ng-template>
                                            </div>

                                        </div>

                                        <div class="beneficiario-actions">

                                            <button type="button" class="btn-beneficiario-action edit"
                                                *ngIf="isBeneficiarioSlotCompleto(i)" (click)="editarBeneficiario(i)">
                                                <i class="fi fi-rr-pencil"></i> Editar
                                            </button>

                                            <button type="button" class="btn-beneficiario-action delete"
                                                *ngIf="isBeneficiarioSlotCompleto(i)" (click)="eliminarBeneficiario(i)">
                                                <i class="fi fi-rr-trash"></i> Eliminar datos
                                            </button>

                                            <button type="button" class="btn-beneficiario-slot-add"
                                                *ngIf="!isBeneficiarioSlotCompleto(i)"
                                                (click)="abrirFormularioAgregarBeneficiario(i)">
                                                <i class="fi fi-rr-plus mr-2"></i>
                                                Agregar beneficiario
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">

                                    <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <button type="button" class="btn btn-secondary btn-pill"
                                        [disabled]="!isBeneficiariosStepValid() || creatingCartSubscription"
                                        (click)="nextFromBeneficiarios()">

                                        <span *ngIf="creatingCartSubscription"
                                            class="spinner-border spinner-border-sm mr-2" role="status"
                                            aria-hidden="true"></span>

                                        {{ creatingCartSubscription ? 'Guardando...' : 'Continuar' }}
                                        <i *ngIf="!creatingCartSubscription" class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>

                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- STEP 4 -->
                    <div *ngIf="steps.planTerminos">

                        <div class="form-content px-4 py-3 plan-terms-content" [formGroup]="planTerminosForm">

                            <h3 class="m-0 title-step">Detalle del plan y términos</h3>
                            <h5 class="m-0 sub-title-step">
                                Revisa el detalle del plan contratado y acepta los términos y condiciones para finalizar
                                la
                                inscripción.
                            </h5>
                            <br>

                            <!-- 1. DETALLE DEL PLAN -->
                            <div class="plan-terms-section-title">
                                1. Detalle del plan
                            </div>

                            <div class="plan-terms-card" *ngIf="getPlanSeleccionado()">

                                <div class="plan-terms-card-top">

                                    <div class="plan-terms-main">
                                        <div class="plan-terms-icon">
                                            <i class="fi fi-rr-heart"></i>
                                        </div>

                                        <div>
                                            <h4>{{ getPlanSeleccionado()?.cus_ben_name || 'Plan contratado' }}</h4>
                                            <p>
                                                {{ getTextoResumenTitularBeneficiarios() }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="plan-terms-price">
                                        <span>Precio mensual</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>

                                </div>

                                <button type="button" class="plan-terms-price-toggle"
                                    (click)="toggleDetallePrecioPlanTerminos()">
                                    {{ mostrarDetallePrecioPlanTerminos ? 'Ocultar detalle del precio' : 'Ver detalle
                                    del precio' }}
                                    <i class="fi"
                                        [ngClass]="mostrarDetallePrecioPlanTerminos ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'">
                                    </i>
                                </button>

                                <div class="plan-terms-price-detail" *ngIf="mostrarDetallePrecioPlanTerminos">

                                    <div class="plan-terms-price-detail-row"
                                        *ngFor="let item of getDetallePrecioPlanTerminos()">
                                        <span>{{ item.label }}</span>
                                        <strong>{{ formatPrecioPlan(item.amount) }}</strong>
                                    </div>

                                    <div class="plan-terms-price-detail-row plan-terms-price-detail-total">
                                        <span>Total</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>

                                </div>

                                <div class="plan-terms-info-grid">

                                    <div class="plan-terms-info-item">
                                        <i class="fi fi-rr-user"></i>

                                        <div>
                                            <span>Tipo de plan</span>
                                            <strong>
                                                {{ getPlanSeleccionado()?.cus_ben_particular ? 'Particular' : 'Convenio'
                                                }}
                                            </strong>
                                        </div>
                                    </div>

                                    <div class="plan-terms-info-item">
                                        <i class="fi fi-rr-calendar"></i>

                                        <div>
                                            <span>Inicio de vigencia</span>
                                            <strong>{{ formatFechaPlan(getFechaInicioVigenciaPlan()) }}</strong>
                                        </div>
                                    </div>
                                    <div class="plan-terms-info-item">
                                        <i class="fi fi-rr-refresh"></i>

                                        <div>
                                            <span>Fecha de renovación</span>
                                            <strong>{{
                                                formatFechaPlan(getFechaRenovacionAnualPlan(getPlanSeleccionado()))
                                                }}</strong>
                                        </div>
                                    </div>

                                    <div class="plan-terms-info-item">
                                        <i class="fi fi-rr-calendar-clock"></i>

                                        <div>
                                            <span>Día de facturación</span>
                                            <strong>{{ getTextoFechaFacturacionPlan(getPlanSeleccionado()) }}</strong>
                                        </div>
                                    </div>


                                </div>

                                <div class="plan-terms-proration-alert"
                                    *ngIf="getDiaFacturacionPlan(getPlanSeleccionado())">
                                    <i class="fi fi-rr-info"></i>
                                    <span>
                                        {{ getTextoPeriodoInicialPlan(getPlanSeleccionado()) }}
                                    </span>
                                </div>

                                <div class="plan-terms-content-grid">

                                    <div class="plan-terms-specialties-box">

                                        <h5>Especialidades y cantidad de consultas del plan</h5>

                                        <div class="plan-terms-specialty-table"
                                            *ngIf="getEspecialidadesPlanSeleccionado().length > 0">

                                            <!-- HEADER -->
                                            <div
                                                class="plan-terms-specialty-head"
                                                [style.grid-template-columns]="
                                                    tieneBeneficiariosSeleccionados()
                                                        ? 'minmax(0, 1fr) 110px 110px'
                                                        : 'minmax(0, 1fr) 110px'
                                                ">

                                                <span>Especialidad</span>

                                                <span>Titular</span>

                                                <span *ngIf="tieneBeneficiariosSeleccionados()">
                                                    Beneficiario
                                                </span>

                                            </div>

                                            <!-- FILAS -->
                                            <div
                                                class="plan-terms-specialty-row"
                                                *ngFor="let especialidad of getEspecialidadesPlanSeleccionado()"
                                                [style.grid-template-columns]="
                                                    tieneBeneficiariosSeleccionados()
                                                        ? 'minmax(0, 1fr) 110px 110px'
                                                        : 'minmax(0, 1fr) 110px'
                                                ">

                                                <!-- ESPECIALIDAD -->
                                                <div class="plan-terms-specialty-cell plan-terms-specialty-main-cell">
                                                    <span class="plan-terms-specialty-mobile-label">
                                                        Especialidad
                                                    </span>

                                                    <div class="plan-terms-specialty-name">
                                                        <i class="fi fi-rr-stethoscope"></i>

                                                        <span>
                                                            {{ especialidad.spe_name }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <!-- CONSULTAS TITULAR -->
                                                <div class="plan-terms-specialty-cell plan-terms-specialty-value-cell">
                                                    <span class="plan-terms-specialty-mobile-label">
                                                        Titular
                                                    </span>

                                                    <strong>
                                                        {{
                                                            getTextoCantidadConsultas(
                                                                especialidad.cus_ben_qty_con_titular
                                                            )
                                                        }}
                                                    </strong>
                                                </div>

                                                <!-- CONSULTAS BENEFICIARIO:
                                                     solo se muestra cuando el usuario
                                                     seleccionó beneficiarios en el Step 3 -->
                                                <div
                                                    class="plan-terms-specialty-cell plan-terms-specialty-value-cell"
                                                    *ngIf="tieneBeneficiariosSeleccionados()">

                                                    <span class="plan-terms-specialty-mobile-label">
                                                        Beneficiario
                                                    </span>

                                                    <strong>
                                                        {{
                                                            getTextoCantidadConsultas(
                                                                especialidad.cus_ben_qty_con_beneficiaries
                                                            )
                                                        }}
                                                    </strong>
                                                </div>

                                            </div>

                                        </div>

                                        <div
                                            class="plan-terms-empty-specialties"
                                            *ngIf="getEspecialidadesPlanSeleccionado().length === 0">

                                            No hay especialidades configuradas para este plan.

                                        </div>

                                        <div class="plan-terms-specialty-note">

                                            <i class="fi fi-rr-info"></i>

                                            <span *ngIf="tieneBeneficiariosSeleccionados()">
                                                Cantidad de consultas disponibles anuales por titular o beneficiario.
                                            </span>

                                            <span *ngIf="!tieneBeneficiariosSeleccionados()">
                                                Cantidad de consultas disponibles anuales para el titular.
                                            </span>

                                        </div>

                                    </div>

                                    <div class="plan-terms-conditions-box">

                                        <h5>Consideraciones del plan</h5>

                                        <p>
                                            {{ getPlanSeleccionado()?.cus_ben_text_consideraciones }}
                                        </p>

                                        <p *ngIf="getPlanSeleccionado()?.cus_ben_description">
                                            {{ getPlanSeleccionado()?.cus_ben_description }}
                                        </p>

                                    </div>

                                </div>

                            </div>

                            <!-- 2. TÉRMINOS Y CONDICIONES -->
                            <div class="plan-terms-section-title mt-4">
                                2. Términos y condiciones
                            </div>

                            <div class="plan-terms-terms-card plan-terms-compact-card"
                                [ngClass]="{ 'accepted': hasAcceptedTerms() }">

                                <div class="plan-terms-checkbox-card">

                                    <label class="plan-terms-external-check">
                                        <input type="checkbox" class="payment-authorization-checkbox"
                                            [checked]="hasAcceptedTerms()"
                                            (change)="onTermsExternalCheckboxChange($event)">

                                        <span class="plan-terms-external-check-text">
                                            <strong>Acepto los términos y condiciones del servicio AlmaMedis</strong>
                                            <span>
                                                Declaro haber revisado las condiciones del plan, su vigencia,
                                                modalidad de cobro mensual, renovación y restricciones asociadas.
                                            </span>
                                        </span>
                                    </label>

                                    <button type="button" class="plan-terms-more-btn" (click)="openTermsModal()">
                                        Ver términos
                                    </button>

                                </div>

                            </div>

                            <div class="plan-terms-acceptance-row">

                                <div class="plan-terms-acceptance-status"
                                    [ngClass]="{ 'accepted': hasAcceptedTerms() }">
                                    <i class="fi" [ngClass]="hasAcceptedTerms() ? 'fi-rr-check-circle' : 'fi-rr-info'">
                                    </i>

                                    <span>
                                        {{ hasAcceptedTerms()
                                        ? 'Términos y condiciones aceptados.'
                                        : 'Debes aceptar los términos y condiciones antes de continuar.' }}
                                    </span>
                                </div>

                              

                            </div>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">

                                    <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <button type="button" class="btn btn-secondary btn-pill"
                                        [disabled]="!isStep3Valid() || updatingCartStep" (click)="nextFromStep3()">

                                        <span *ngIf="updatingCartStep" class="spinner-border spinner-border-sm mr-2"
                                            role="status" aria-hidden="true"></span>

                                        {{ updatingCartStep ? 'Actualizando...' : 'Continuar' }}
                                        <i *ngIf="!updatingCartStep" class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>

                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- STEP 5 -->
                    <div *ngIf="steps.validacion && canValidateAutentika">

                        <div class="form-content px-4 py-3">

                            <h3 class="m-0 title-step">Validación de identidad y firma</h3>
                            <h5 class="m-0 sub-title-step">
                                Para continuar con tu inscripción, debes validar tu identidad y firmar el contrato
                            </h5>

                            <p class="step-description">
                                Escanea el código QR para completar el proceso. Una vez finalizado, vuelve a esta
                                pantalla para continuar con el paso final de inscripción de pago.
                            </p>

                            <div class="validation-wrapper">

                                <div class="validation-link-card">
                                    <div class="validation-phone-icon">
                                        <i class="fi fi-rr-mobile-notch"></i>
                                    </div>

                                    <h5>Escanea este código QR</h5>
                                    <p>desde tu celular para iniciar la validación y firma.</p>

                                    <div class="validation-divider">
                                        <span>o</span>
                                    </div>

                                    <p class="validation-small-text">
                                        Ingresa directamente al siguiente enlace:
                                    </p>

                                    <div class="validation-url-box">
                                        <span>{{ autenticarData.link }}</span>
                                        <button type="button" (click)="copiarLinkValidacion()">
                                            <i class="fi fi-rr-copy"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="validation-qr-card">
                                    <div class="qr-placeholder">
                                        <div></div>
                                    </div>
                                </div>

                            </div>

                            <div class="validation-status-box"
                                [ngClass]="{ 'validated': validacionForm.get('identidadValidada')?.value === true }">

                                <div class="validation-status-icon">
                                    <i class="fi fi-rr-info"></i>
                                </div>

                                <div>
                                    <h5>
                                        Estado actual:
                                        {{ validacionForm.get('identidadValidada')?.value ? 'validación completada' :
                                        'pendiente de validación y firma' }}
                                    </h5>

                                    <p *ngIf="!validacionForm.get('identidadValidada')?.value">
                                        El sistema está a la espera de que completes el proceso de validación y firma
                                        desde tu celular.
                                        Una vez completado el proceso, vuelve a esta pantalla para continuar con el paso
                                        final de inscripción de pago.
                                    </p>

                                    <p *ngIf="validacionForm.get('identidadValidada')?.value">
                                        La validación fue completada correctamente. Puedes continuar con la inscripción
                                        de pago.
                                    </p>
                                </div>

                            </div>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">

                                    <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <div class="d-flex step4-actions">
                                        <button type="button" class="btn btn-light btn-pill mr-2"
                                            (click)="simularValidacionCompletada()">
                                            Simular validación
                                        </button>

                                        <button type="button" class="btn btn-secondary btn-pill"
                                            [disabled]="!isStep4Valid() || updatingCartStep" (click)="nextFromStep4()">

                                            <span *ngIf="updatingCartStep" class="spinner-border spinner-border-sm mr-2"
                                                role="status" aria-hidden="true"></span>

                                            {{ updatingCartStep ? 'Actualizando...' : 'Continuar' }}
                                            <i *ngIf="!updatingCartStep" class="fi fi-rr-arrow-right ml-2"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- STEP PAGO -->
                    <div *ngIf="steps.pago">

                        <div class="form-content px-4 py-3 payment-step-content" [formGroup]="pagoForm">

                            <h3 class="m-0 title-step">Inscripción de pago</h3>

                            <h5 class="m-0 payment-step-subtitle">
                                Para completar tu inscripción, autoriza la suscripción mensual con alguno de los medios
                                de pago disponibles.
                            </h5>

                            <p class="payment-step-description">
                                Serás redirigido a la plataforma de pago para autorizar el pago recurrente.
                                Una vez realizado el pago de forma exitosa recibirás la confirmación y bienvenida a tu correo electrónico.
                            </p>

                            <div class="payment-section">

                                <h5 class="payment-section-title">1. Método de pago</h5>

                                <div class="payment-method-card payment-method-card-v2" *ngIf="canUseMercadoPago()" [ngClass]="{ 'selected': pagoForm.get('metodoPago')?.value === 'MERCADO_PAGO' }" (click)="seleccionarMetodoPago('MERCADO_PAGO')">
                                    <div class="payment-radio"><span></span></div>
                                    <div class="payment-logo payment-logo-mp"><img src="../../assets/images/logoMP.png" alt="Mercado Pago"></div>
                                    <div class="payment-method-info"><h5>Mercado Pago</h5><p>Paga con tarjeta de crédito o débito.</p></div>
                                </div>
                                <div class="payment-method-card payment-method-card-v2 mt-3" *ngIf="canUseVirtualPos()" [ngClass]="{ 'selected': pagoForm.get('metodoPago')?.value === 'VIRTUAL_POS' }" (click)="seleccionarMetodoPago('VIRTUAL_POS')">
                                    <div class="payment-radio"><span></span></div>
                                    <div class="payment-logo payment-logo-mp"><img src="../../assets/images/logoVP.svg" alt="Virtual Pos"></div>
                                    <div class="payment-method-info"><h5>Virtual Pos</h5><p>Autoriza el pago recurrente con tu tarjeta.</p></div>
                                </div>
                                <div class="not-hours mt-3" *ngIf="!hasAvailablePaymentMethods()"><div class="d-flex"><i class="fi fi-rr-info d-flex align-items-center"></i><span>No hay métodos de pago habilitados para este convenio.</span></div></div>
                                <small class="text-danger d-block mt-2" *ngIf="pagoForm.get('metodoPago')?.touched && pagoForm.get('metodoPago')?.hasError('required')">Debes seleccionar un método de pago.</small>

                            </div>

                            <div class="payment-section">

                                <h5 class="payment-section-title">2. Revisa y autoriza la suscripción</h5>

                                <div class="payment-summary-box payment-summary-box-v2">

                                    <div class="payment-summary-row">
                                        <span>Nombre del plan</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_name || '—' }}</strong>
                                    </div>

                                    <div class="payment-summary-row">
                                        <span>Precio final</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>

                                    <div class="payment-summary-row">
                                        <span>Empresa / convenio asociado</span>
                                        <strong>{{ getNombreConvenio() }}</strong>
                                    </div>

                                    <div class="payment-summary-row">
                                        <span>Tipo de pago</span>
                                        <strong>Suscripción mensual</strong>
                                    </div>

                                </div>

                                <label class="payment-authorization-box payment-authorization-box-v2">
                                    <input type="checkbox" class="payment-authorization-checkbox"
                                        formControlName="autorizaPlanilla">

                                    <span>
                                        Autorizo la suscripción de un cobro recurrente al medio de pago seleccionado según las condiciones del plan seleccionado
                                    </span>
                                </label>

                            </div>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">

                                    <button type="button" class="btn btn-light btn-pill payment-back-btn"
                                        (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <button type="button" class="btn btn-secondary btn-pill payment-submit-btn"
                                        [disabled]="!isStep5Valid() || loadingSubmit" (click)="enviarFormulario()">

                                        <span *ngIf="loadingSubmit" class="spinner-border spinner-border-sm mr-2"
                                            role="status" aria-hidden="true"></span>

                                        {{ loadingSubmit ? 'Redirigiendo...' : 'Inscribir pago' }}
                                        <i *ngIf="!loadingSubmit" class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>

                                </div>
                            </div>

                            <!-- <div class="payment-inline-help">
                                <i class="fi fi-rr-headset"></i>
                                <span>¿Necesitas ayuda? Contáctanos en</span>
                                <a *ngIf="getCorreoCustomer()" [href]="getCorreoCustomerHref()">
                                    {{ getCorreoCustomer() }}
                                </a>
                            </div> -->

                        </div>

                    </div>

                </div>

            </div>

        </div>


        <!-- PANTALLA FINAL PAGO EXITOSO -->
<div
    class="row mt-xl-3 mx-0 justify-content-center"
    *ngIf="showSuccessPaymentScreen">

    <div
        class="col-12 p-0"
        style="display: flex; justify-content: center;">

        <div class="card success-payment-card">

            <!-- ICONO -->
            <div class="success-payment-icon">
                <i class="fi fi-rr-check"></i>
            </div>

            <!-- TITULO -->
            <h1 class="success-payment-title">
                ¡Inscripción finalizada con éxito!
            </h1>

            <p class="success-payment-subtitle">
                Tu suscripción fue autorizada correctamente.
            </p>

            <!-- LOGOS -->
            <div class="success-payment-logos">

                <div
                    class="success-logo-main"
                    *ngIf="getLogoDefault()">

                    <img
                        [src]="getLogoDefault()"
                        [alt]="getNombreDefault()">

                </div>

                <div
                    class="success-logo-client"
                    *ngIf="showLogoCustomer()">

                    <img
                        [src]="getLogoCustomer()"
                        [alt]="getNombreCustomer()">

                </div>

            </div>

            <div class="success-contact-box">
                <div class="success-contact-title m-0">
                    <i class="fi fi-rr-check-circle"></i>
                    <span>
                        Tu plan quedó activo correctamente y la suscripción mensual fue registrada.
                    </span>
                </div>
            </div>



            <p class="success-payment-message mt-3">
                Te enviaremos un correo con la confirmación
                de tu inscripción y la información necesaria
                para comenzar a utilizar los beneficios de tu plan.
            </p>


            <!-- SOPORTE -->
            <div class="success-contact-box">

                <div class="success-contact-title">

                    <i class="fi fi-rr-info"></i>

                    <span>
                        Si necesitas ayuda con tu plan o con el uso
                        de la plataforma, puedes comunicarte con nosotros.
                    </span>

                </div>

                <div class="success-contact-actions">

                    <a
                        *ngIf="getCorreoCustomer()"
                        [href]="getCorreoCustomerHref()"
                        class="success-contact-action">

                        <i class="fi fi-rr-envelope"></i>

                        <span>
                            {{ getCorreoCustomer() }}
                        </span>

                    </a>

                    <a
                        *ngIf="getTelefonoCustomer()"
                        [href]="getTelefonoCustomerHref()"
                        class="success-contact-action">

                        <i class="fi fi-rr-phone-call"></i>

                        <span>
                            {{ getTelefonoCustomer() }}
                        </span>

                    </a>

                </div>

            </div>


            <button
                type="button"
                class="success-primary-btn"
                (click)="irAlInicio()">

                Ir al inicio

                <i class="fi fi-rr-arrow-right ml-2"></i>

            </button>

        </div>

    </div>

</div>

        <!-- PANTALLA FINAL PAGO FALLIDO -->
        <div class="row mt-xl-3 mx-0 justify-content-center" *ngIf="showFailedPaymentScreen">
            <div class="col-12 p-0" style="display: flex; justify-content: center;">
                <div class="card success-payment-card">

                    <div class="success-payment-icon" style="background:#fff5f5; border-color:#ffa8a8; color:#c92a2a;">
                        <i class="fi fi-rr-cross-small" style="color:#c92a2a;"></i>
                    </div>

                    <h1 class="success-payment-title"> 
                        No fue posible finalizar la inscripción
                    </h1>

                    <p class="success-payment-subtitle">
                        {{ paymentReturnMessage || 'El pago o la autorización de suscripción no fue aprobada.' }}
                    </p>

                    <div class="success-contact-box">
                        <div class="success-contact-title">
                            <i class="fi fi-rr-info"></i>
                            <span>
                                Puedes intentar nuevamente o contactar a soporte si el problema persiste.
                            </span>
                        </div>

                        <div class="success-contact-actions">
                            <a *ngIf="getCorreoCustomer()" [href]="getCorreoCustomerHref()"
                                class="success-contact-action">
                                <i class="fi fi-rr-envelope"></i>
                                <span>{{ getCorreoCustomer() }}</span>
                            </a>
                        </div>
                    </div>

                    <button type="button" class="success-primary-btn" (click)="reiniciarInscripcion()">
                        Intentar nuevamente
                        <i class="fi fi-rr-arrow-right ml-2"></i>
                    </button>

                </div>
            </div>
        </div>

        <!-- FOOTER AYUDA -->
        <div class="help-footer">
            <i class="fi fi-rr-headset"></i>
            <span>¿Necesitas ayuda? Contáctanos llamando al</span>
            <a *ngIf="getTelefonoCustomer()" [href]="getTelefonoCustomerHref()">
                {{ getTelefonoCustomer() }}
            </a>
            <span>o escribiendo a</span>
            <a *ngIf="getCorreoCustomer()" [href]="getCorreoCustomerHref()">
                {{ getCorreoCustomer() }}
            </a>
        </div>

    </ng-container>


    <!-- MODAL TÉRMINOS Y CONDICIONES -->
    <div class="modal fade show d-block terms-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true"
        style="background: rgba(0,0,0,.5);" *ngIf="showTermsModal">

        <div class="modal-dialog terms-modal-dialog" role="document">
            <div class="modal-content terms-modal-content">

                <div class="modal-header terms-modal-header">
                    <div>
                        <h5 class="modal-title terms-modal-title">Términos y condiciones</h5>
                        <p class="terms-modal-subtitle mb-0">
                            Revisa el documento. La aceptación se realiza marcando el checkbox en la pantalla anterior.
                        </p>
                    </div>

                    <button type="button" class="close terms-modal-close" (click)="closeTermsModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body terms-modal-body">
                    <div class="terms-modal-scroll" (scroll)="onTermsScroll($event)">

                        <ng-container *ngFor="let section of termsAndConditions">
                            <h5 class="terms-modal-section-title">{{ section.title }}</h5>

                            <p *ngFor="let paragraph of section.paragraphs">
                                {{ paragraph }}
                            </p>

                            <ul class="terms-modal-list" *ngIf="section.bullets?.length">
                                <li *ngFor="let bullet of section.bullets">
                                    {{ bullet }}
                                </li>
                            </ul>
                        </ng-container>

                    </div>

                    <div class="terms-modal-scroll-help" *ngIf="!termsScrolledToBottom">
                        <i class="fi fi-rr-info"></i>
                        <span>Puedes desplazarte hasta el final para revisar todo el documento antes de cerrarlo.</span>
                    </div>
                </div>

                <div class="modal-footer terms-modal-footer">
                    <button type="button" class="btn btn-light btn-pill" (click)="closeTermsModal()">
                        Cerrar
                    </button>

                    <button type="button" class="btn btn-secondary btn-pill" (click)="acceptTermsFromModal()">
                        Entendido
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- MODAL BENEFICIARIO -->
    <div class="modal fade show d-block beneficiario-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true"
        style="background: rgba(0,0,0,.5);" *ngIf="mostrarFormularioBeneficiario">

        <div class="modal-dialog beneficiario-modal-dialog" role="document">
            <div class="modal-content beneficiario-modal-content" [formGroup]="beneficiarioForm">

                <div class="modal-header beneficiario-modal-header">
                    <div>
                        <h5 class="modal-title beneficiario-modal-title">
                            {{ indexBeneficiarioEditando !== null ? 'Editar beneficiario' : 'Agregar beneficiario' }}
                        </h5>
                        <p class="beneficiario-modal-subtitle mb-0">
                            Completa los datos personales para sumarlo a la inscripción del plan.
                        </p>
                    </div>

                    <button type="button" class="close beneficiario-modal-close"
                        (click)="cerrarFormularioBeneficiario()" aria-label="Cerrar">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body beneficiario-modal-body">

                    <div class="form-row">

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">RUT beneficiario*</label>

                            <input type="text" class="form-control form-control-rounded" placeholder="Ej: 12.345.678-9"
                                formControlName="rut" (blur)="onBeneficiarioRutBlur()"
                                (keypress)="allowOnlyRutChars($event)">

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('rut')?.touched && beneficiarioForm.get('rut')?.hasError('required')">
                                El RUT del beneficiario es obligatorio.
                            </small>

                            <small class="text-danger d-block mt-1"
                                *ngIf="(beneficiarioForm.get('rut')?.touched || beneficiarioForm.get('rut')?.dirty) && beneficiarioForm.get('rut')?.hasError('rutInvalido')">
                                El RUT ingresado no es válido.
                            </small>
                            <small class="text-danger"
                                *ngIf="(beneficiarioForm.get('rut')?.touched || beneficiarioForm.get('rut')?.dirty) && beneficiarioForm.get('rut')?.hasError('rutIgualTitular')">
                                El beneficiario no puede tener el mismo RUT del titular.
                            </small>

                            <small class="text-danger"
                                *ngIf="(beneficiarioForm.get('rut')?.touched || beneficiarioForm.get('rut')?.dirty) && beneficiarioForm.get('rut')?.hasError('rutBeneficiarioDuplicado')">
                                Este RUT ya fue ingresado como beneficiario.
                            </small>
                        </div>



                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Nombre*</label>

                            <input type="text" class="form-control form-control-rounded" placeholder="Nombre"
                                formControlName="nombre" (keypress)="allowOnlyLetters($event)">

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('nombre')?.touched && beneficiarioForm.get('nombre')?.hasError('required')">
                                El nombre es obligatorio.
                            </small>
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Primer apellido*</label>

                            <input type="text" class="form-control form-control-rounded" placeholder="Primer apellido"
                                formControlName="primerApellido" (keypress)="allowOnlyLetters($event)">

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('primerApellido')?.touched && beneficiarioForm.get('primerApellido')?.hasError('required')">
                                El primer apellido es obligatorio.
                            </small>
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Segundo apellido</label>

                            <input type="text" class="form-control form-control-rounded" placeholder="Segundo apellido"
                                formControlName="segundoApellido" (keypress)="allowOnlyLetters($event)">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Fecha de nacimiento*</label>

                            <input type="date" class="form-control form-control-rounded"
                                formControlName="fechaNacimiento" [attr.max]="todayDate">

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('fechaNacimiento')?.touched && beneficiarioForm.get('fechaNacimiento')?.hasError('required')">
                                La fecha de nacimiento es obligatoria.
                            </small>

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('fechaNacimiento')?.touched && beneficiarioForm.get('fechaNacimiento')?.hasError('fechaMayorActual')">
                                La fecha de nacimiento no puede ser mayor a la fecha actual.
                            </small>

                        </div>
                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Email beneficiario*</label>

                            <input type="email" class="form-control form-control-rounded"
                                placeholder="correo@ejemplo.cl" formControlName="email">

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('email')?.touched && beneficiarioForm.get('email')?.hasError('required')">
                                El email del beneficiario es obligatorio.
                            </small>

                            <small class="text-danger d-block mt-1"
                                *ngIf="beneficiarioForm.get('email')?.touched && beneficiarioForm.get('email')?.hasError('emailFormatoInvalido')">
                                El correo ingresado no tiene un formato válido.
                            </small>
                        </div>

                    </div>

                </div>

                <div class="modal-footer beneficiario-modal-footer">
                    <button type="button" class="btn btn-light btn-pill" (click)="cerrarFormularioBeneficiario()">
                        Cancelar
                    </button>

                    <button type="button" class="btn btn-secondary btn-pill" (click)="guardarBeneficiario()">
                        {{ indexBeneficiarioEditando !== null ? 'Guardar cambios' : 'Guardar beneficiario' }}
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- MODAL LIMPIAR -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);"
        *ngIf="mostrarModalLimpiar">

        <div class="modal-dialog" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">¿Limpiar formulario?</h5>

                    <button type="button" class="close" (click)="cerrarModalLimpiar()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-center">
                    <div class="mb-3">
                        <i class="fi fi-rr-triangle-warning" style="font-size:42px;color:#f59e0b;"></i>
                    </div>

                    <p class="mb-0">
                        Al limpiar el formulario se eliminarán los datos ingresados junto con los beneficiarios
                        agregados.
                        <br>
                        ¿Deseas continuar?
                    </p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-pill" (click)="cerrarModalLimpiar()">
                        Cancelar
                    </button>

                    <button type="button" class="btn btn-secondary btn-pill" (click)="limpiarFormulario()">
                        Limpiar
                    </button>
                </div>

            </div>
        </div>
    </div>

</div>